import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Fires a Meta Pixel PageView on every client-side route change.
 *
 * The base pixel in index.html only fires PageView on the initial HTML load.
 * Because this is a single-page app, navigating between routes does not reload
 * the page — so without this, only the first view would ever be tracked.
 * Must be rendered INSIDE the Router (it uses useLocation). Renders nothing.
 */
export default function MetaPixelTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq('track', 'PageView');
    }
  }, [pathname]);

  return null;
}
